import type { IconProps } from './../../models/icon';

export function MailIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill="#fff"
          d="M4.28564 13.1915L11.9999 18L19.7142 13.1915V2.57146C19.7142 2.1168 19.5335 1.68077 19.2121 1.35928C18.8907 1.03779 18.4546 0.857178 17.9999 0.857178H5.99993C5.54527 0.857178 5.10924 1.03779 4.78774 1.35928C4.46626 1.68077 4.28564 2.1168 4.28564 2.57146V13.1915Z"
        />
        <path
          fill={secondaryColor}
          d="M22.2858 21.4285V11.5885L12.0001 17.9999L1.71436 11.5885V21.4285C1.71436 21.8831 1.89497 22.3193 2.21645 22.6407C2.53795 22.9621 2.97398 23.1428 3.42864 23.1428H20.5715C21.0261 23.1428 21.4622 22.9621 21.7837 22.6407C22.1051 22.3193 22.2858 21.8831 22.2858 21.4285Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M22.2858 10.2858V21.4286C22.2858 21.8833 22.1051 22.3194 21.7837 22.6408C21.4622 22.9622 21.0261 23.1429 20.5715 23.1429H3.42864C2.97398 23.1429 2.53795 22.9622 2.21645 22.6408C1.89497 22.3194 1.71436 21.8833 1.71436 21.4286V10.2858"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M0.986792 11.1352C1.2372 10.7334 1.76587 10.6108 2.1676 10.8612L11.9999 16.99L21.8322 10.8612C22.2339 10.6108 22.7626 10.7334 23.013 11.1352C23.2634 11.5369 23.1408 12.0656 22.739 12.316L12.4533 18.7274C12.1758 18.9004 11.824 18.9004 11.5465 18.7274L1.26078 12.316C0.859048 12.0656 0.736379 11.5369 0.986792 11.1352Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M5.9999 1.71429C5.77257 1.71429 5.55457 1.80458 5.39381 1.96533C5.3938 1.96533 5.3938 1.96534 5.39379 1.96534M5.39379 1.96534C5.23305 2.1261 5.14275 2.34411 5.14275 2.57143V8.57143C5.14275 9.04482 4.759 9.42857 4.28561 9.42857C3.81222 9.42857 3.42847 9.04482 3.42847 8.57143V2.57143C3.42847 1.88943 3.69939 1.23539 4.1816 0.753165L4.18162 0.753147C4.66386 0.27092 5.3179 0 5.9999 0H17.9999C18.6818 0 19.336 0.270886 19.8182 0.753212C20.3003 1.23536 20.5713 1.88935 20.5713 2.57143V8.57143C20.5713 9.04482 20.1876 9.42857 19.7142 9.42857C19.2408 9.42857 18.857 9.04482 18.857 8.57143V2.57143C18.857 2.34418 18.7667 2.12611 18.6059 1.96528C18.4453 1.80462 18.2272 1.71429 17.9999 1.71429H5.9999"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M8.57153 5.99997C8.57153 5.52658 8.95529 5.14282 9.42868 5.14282H14.5715C15.0449 5.14282 15.4287 5.52658 15.4287 5.99997C15.4287 6.47335 15.0449 6.85711 14.5715 6.85711H9.42868C8.95529 6.85711 8.57153 6.47335 8.57153 5.99997Z"
          clipRule="evenodd"
        />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M8.57153 10.2857C8.57153 9.81234 8.95529 9.42859 9.42868 9.42859H14.5715C15.0449 9.42859 15.4287 9.81234 15.4287 10.2857C15.4287 10.7591 15.0449 11.1429 14.5715 11.1429H9.42868C8.95529 11.1429 8.57153 10.7591 8.57153 10.2857Z"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
}
